import _ from "lodash";

export const formatVehicle = billOfLading => {
  if (_.isEmpty(billOfLading)) return "";
  return `${billOfLading.vehicleId}${billOfLading.bookingNumber ? ` / ${billOfLading.bookingNumber}` : ""}`;
};



// WEBPACK FOOTER //
// ./src/helpers/vehicleHelpers.js